export default "__VITE_ASSET__DJZnqwZq__"